import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorComponent } from './components/error/error.component';
import { ConfirmMailComponent } from './components/confirm-mail/confirm-mail.component';
import { RatingsComponent } from './components/ratings/ratings.component';
import { MainComponent } from './components/main/main.component';
import { ValidationAnimationComponent } from './components/validation-animation/validation-animation.component';
import { JwtModule } from '@auth0/angular-jwt';
import { httpInterceptorProviders } from './shared/http-interceptors';
import { AdminComponent } from './components/admin/admin.component';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UserMenuComponent } from './components/main/user-menu/user-menu.component';
import { AdminHomeComponent } from './components/admin/admin-home/admin-home.component';
import { AdminPushComponent } from './components/admin/admin-push/admin-push.component';
import { AdminRantingComponent } from './components/admin/admin-ranting/admin-ranting.component';
import { OpenDialogAddNotificationComponent } from './components/dialog/open-dialog-add-notification/open-dialog-add-notification.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ErrorAnimationComponent } from './components/error-animation/error-animation.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { NgRatingBarModule } from 'ng-rating-bar';
import { environment } from 'environments/environment';
import { RateComponent } from './components/ratings/rate/rate.component';
import { TableSubmovieComponent } from './components/admin/admin-ranting/table-submovie/table-submovie.component';
import { VotingBarsComponent } from './components/ratings/rate/voting-bars/voting-bars.component';
import { DialogComponent } from './components/dialog/dialog-component/dialog.component';


export function tokenGetterFactory(): string {
  return localStorage.getItem(environment.tokenKey) as string;
}
registerLocaleData(localeFr, 'fr');


@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
    RatingsComponent,
    ConfirmMailComponent,
    ResetPasswordComponent,
    MainComponent,
    ValidationAnimationComponent,
    ErrorAnimationComponent,
    SignInComponent,
    AdminComponent,
    AdminHomeComponent,
    AdminPushComponent,
    AdminRantingComponent,
    UserMenuComponent,
    OpenDialogAddNotificationComponent,
    RateComponent,
    TableSubmovieComponent,
    VotingBarsComponent,
    DialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    NgRatingBarModule,

    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetterFactory,
        allowedDomains: [environment.apiDomain],
        disallowedRoutes: [environment.identityApiUrl + 'connect/token']
      }
    }),
  ],
  providers: [
    httpInterceptorProviders,
    { provide: LOCALE_ID, useValue: 'fr' },


  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

